import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AirportMessageAdd, Airport, AirportMessageRecord } from '../types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AirportMessageService {
  url = '/api/fuel-app/airport-message';
  constructor(private http: HttpClient) {}

  getAll(): Observable<AirportMessageRecord[]> {
    return this.http.get<AirportMessageRecord[]>(
      this.url
    );
  }

  getAllAirport(): Observable<Airport[]> {
    return this.http.get<Airport[]>(`${this.url}/airport`);
  }
  
  add(
    airportMessageAdd: AirportMessageAdd
  ): Observable<void> {
    return this.http.post<any>(
      this.url,
      airportMessageAdd);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }
}
